import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Container,
  Wrapper,
  Title,
  CardContainer,
  ToggleButtonGroup,
  ToggleButton,
  Divider,
} from "./ProjectsStyle";
import ProjectCard from "../Cards/ProjectCards";

import axiosInstance from "../../axiosInstance";
import Loader from "../Loader/Loader";

const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState("all");
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState(["all"]);

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    setLoading(true);
    const timeoutId = setTimeout(async () => {
      try {
        const res = await axiosInstance.get("/projects");
        setProjects(res.data);
      } catch (err) {
        setProjects([]);
      } finally {
        setLoading(false);
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, []);

  // Extract unique categories after projects are loaded
  useEffect(() => {
    if (projects.length > 0) {
      const uniqueCategories = Array.from(
        new Set(projects.map((p) => p.category).filter(Boolean))
      );
      setCategories(["all", ...uniqueCategories]);
    } else {
      setCategories(["all"]);
    }
  }, [projects]);

  if (loading) {
    return <Loader />;
  }

  return (
    <Container id="projects">
      <Wrapper>
        <Title data-aos="zoom-in-down">PROJECTS</Title>
        <ToggleButtonGroup data-aos="zoom-in-up">
          {categories.map((cat, idx) => (
            <React.Fragment key={cat}>
              <ToggleButton
                active={toggle === cat}
                value={cat}
                onClick={() => setToggle(cat)}
              >
                {cat === "all" ? "All" : cat}
              </ToggleButton>
              {idx < categories.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </ToggleButtonGroup>
        <CardContainer data-aos="zoom-in-down">
          {(toggle === "all"
            ? projects
            : projects.filter((item) => item.category === toggle)
          ).map((project) => (
            <ProjectCard
              project={project}
              openModal={openModal}
              setOpenModal={setOpenModal}
              key={project.id}
            />
          ))}
        </CardContainer>
      </Wrapper>
    </Container>
  );
};

export default Projects;
